import { Routes } from "@angular/router";

const Routing: Routes = [
  {
    path: "default-component",
    loadChildren: () =>
      import("./default-component/default-component.module").then(
        (m) => m.DefaultComponentModule
      ),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "entry-information",
    loadChildren: () =>
      import("./entry-information/entry-information.module").then((m) => m.EntryInformationModule),
  },
  {
    path: "leave-late-information",
    loadChildren: () =>
      import("./leave-late-information/leave-late-information.module").then((m) => m.LeaveLateInformationModule),
  },
  {
    path: "salary",
    loadChildren: () =>
      import("./salary/salary.module").then((m) => m.SalaryModule),
  },
  {
    path: "employee",
    loadChildren: () =>
      import("./employee/employee.module").then((m) => m.EmployeeModule),
  },
  {
    path: "user",
    loadChildren: () =>
      import("./user/user.module").then((m) => m.UserModule),
  },
  {
    path: "permission",
    loadChildren: () =>
      import("./permission/permission.module").then((m) => m.PermissionModule),
  },
  {
    path: "holiday",
    loadChildren: () =>
      import("./holiday/holiday.module").then((m) => m.HolidayModule),
  },
  {
    path: "leave",
    loadChildren: () =>
      import("./leave/leave.module").then((m) => m.LeaveModule),
  },
  {
    path: "fine",
    loadChildren: () =>
      import("./fine/fine.module").then((m) => m.FineModule),
  },
  {
    path: "working-year",
    loadChildren: () =>
      import("./working-years/working-years.module").then((m) => m.WorkingYearsModule),
  },
  {
    path: "company-information",
    loadChildren: () =>
      import("./company-information/company-information.module").then((m) => m.CompanyInformationModule),
  },
  {
    path: "department-information",
    loadChildren: () =>
      import("./department-information/department-information.module").then((m) => m.DepartmentInformationModule),
  },
  {
    path: "job-position",
    loadChildren: () =>
      import("./job-position/job-position.module").then((m) => m.JobPositionModule),
  },
  {
    path: "policy-management",
    loadChildren: () =>
      import("./policy-management/policy-management.module").then((m) => m.PolicyManagementModule),
  },
  {
    path: "builder",
    loadChildren: () =>
      import("./builder/builder.module").then((m) => m.BuilderModule),
  },
  {
    path: "crafted/pages/profile",
    loadChildren: () =>
      import("../modules/profile/profile.module").then((m) => m.ProfileModule),
    // data: { layout: 'light-sidebar' },
  },
  {
    path: "crafted/account",
    loadChildren: () =>
      import("../modules/account/account.module").then((m) => m.AccountModule),
    // data: { layout: 'dark-header' },
  },
  {
    path: "crafted/pages/wizards",
    loadChildren: () =>
      import("../modules/wizards/wizards.module").then((m) => m.WizardsModule),
    // data: { layout: 'light-header' },
  },
  {
    path: "crafted/widgets",
    loadChildren: () =>
      import("../modules/widgets-examples/widgets-examples.module").then(
        (m) => m.WidgetsExamplesModule
      ),
    // data: { layout: 'light-header' },
  },
  {
    path: "apps/chat",
    loadChildren: () =>
      import("../modules/apps/chat/chat.module").then((m) => m.ChatModule),
    // data: { layout: 'light-sidebar' },
  },
  {
    path: "apps/roles",
    loadChildren: () => import("./role/role.module").then((m) => m.RoleModule),
  },
  {
    path: "special-leaves",
    loadChildren: () =>
      import("./special-leaves/special-leaves.module").then(
        (m) => m.SpecialLeavesModule
      ),
  },
  {
    path: 'allowances',
    loadChildren: () => import('./allowances/allowances.module').then(m => m.AllowancesModule)
  },
  {
    path: 'commissions',
    loadChildren: () => import('./commissions/commissions.module').then(m => m.CommissionsModule)
  },
  {
    path: 'others',
    loadChildren: () => import('./others/others.module').then(m => m.OthersModule)
  },
  {
    path: 'collect-points',
    loadChildren: () => import('./collect-points/collect-points.module').then(m => m.CollectPointsModule)
  },
  {
    path: 'payroll-slips',
    loadChildren: () => import('./payroll-slips/payroll-slips.module').then(m => m.PayrollSlipsModule)
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('./audit-logs/audit-logs.module').then(m => m.AuditLogsModule)
  },
  {
    path: 'report-attendance-leavings',
    loadChildren: () => import('./report-attendance-leavings/report-attendance-leavings.module').then(m => m.ReportAttendanceLeavingsModule)
  },
  { path: 'change-password', loadChildren: () => import('./change-passwords/change-passwords.module').then(m => m.ChangePasswordsModule) },


  {
    path: "",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "error/404",
  },
];

export { Routing };
